import React, { useEffect, useRef, useState } from "react";

import { useSelector } from "react-redux";

import { ReactComponent as IconMessage18 } from "../../icons/icon/18/a-icon-message-18.svg";
import { ReactComponent as IconMessage24 } from "../../icons/icon/24/a-icon-message-24.svg";
import { formatInTimeZone } from "../../utils/dateHelper";
import AdaptiveIcon from "../adaptiveIcon/adaptiveIcon";
import IconButton from "../button/iconButton";
import MediaLightbox from "../lightbox/mediaLightbox";

import "./chatButton.scss";

const businessHours = {
  gb: {
    end: 17,
    start: 9,
    timeZone: "Europe/London",
    workingWeekBegin: 1,
    workingWeekEnd: 5,
  },
};

const isBusinessHours = () => {
  const currentBusinessHours = businessHours[process.env.GATSBY_SITE];

  if (!currentBusinessHours) {
    return false;
  }

  const date = new Date(formatInTimeZone(new Date(), "yyyy/MM/dd HH:mm", currentBusinessHours.timeZone));

  return date.getDay() >= currentBusinessHours.workingWeekBegin
    && date.getDay() <= currentBusinessHours.workingWeekEnd
    && date.getHours() >= currentBusinessHours.start
    && date.getHours() < currentBusinessHours.end;
};

const chatScript = () => {
  try {
    const chatSettings = JSON.parse(process.env.GATSBY_CHAT_SF_ENV);

    window.embeddedservice_bootstrap.settings.language = "en_US"; // For example, enter 'en' or 'en-US'

    window.addEventListener("onEmbeddedMessagingReady", () => {
      window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(
        { Chat_Start_Webpage: window.location.pathname },
      );
    });

    window.embeddedservice_bootstrap.init(
      chatSettings.id,
      chatSettings.name,
      chatSettings.link,
      {
        scrt2URL: chatSettings.scrt2URL,
      },
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("Error loading Embedded Messaging: ", err);
  }
};

const ChatButton = () => {
  if (process.env.GATSBY_ENABLE_CHAT?.toLowerCase() !== "true") return null;

  const chatSettings = JSON.parse(process.env.GATSBY_CHAT_SF_ENV);
  const externalContentEnabled = useSelector((state) => (
    state.complianceConsent.externalContentEnabled
  ));

  const mediaModal = useRef();

  useEffect(() => {
    const script = document.createElement("script");
    script.id = "sfMessage";
    script.type = "text/javascript";
    script.src = `${chatSettings.link}/assets/js/bootstrap.min.js`;
    script.async = true;
    script.onload = () => {
      window.initEmbeddedMessaging();
    };

    if (externalContentEnabled) {
      mediaModal?.current?.close();
      window.initEmbeddedMessaging = chatScript;
      document.body.appendChild(script);
    } else {
      document.getElementById(script.id)?.remove();
      document.getElementById("embedded-messaging")?.remove();
      document.getElementById("embeddedMessagingSiteContextFrame")?.remove();
      document.getElementById("inert-script")?.remove();
      window.initEmbeddedMessaging = undefined;
    }
  }, [externalContentEnabled]);

  const [clientSide, setClientSide] = useState(false);

  useEffect(() => {
    setClientSide(true);
  }, []);

  if (!clientSide || !isBusinessHours() || externalContentEnabled) {
    return null;
  }

  return (
    <>
      <IconButton
        onClick={() => {
          mediaModal.current.show();
        }}
        variant="dark"
        iconOnly
        className="chat-button"
      >
        <AdaptiveIcon sm={<IconMessage18 />} lg={<IconMessage24 />} />
      </IconButton>
      <MediaLightbox
        ref={mediaModal}
      />
    </>
  );
};

export default ChatButton;
